import moment from 'moment';
const endpoint = 'https://api.mixcloud.com/KioskRadio/cloudcasts/?limit=50';

export class Mixcloud {
  constructor () {
    this.episodes = [];
    this.searchResults = [];
  }

  load () {
    return new Promise((resolve, reject) => {
      window.fetch(endpoint).then(response => response.json()).then(data => {
        this.episodes = this.parseResult(data);
        resolve(this.episodes);
      }).catch(reject);
    })
  }

  search (term) {
    if (term.split('')[0] === '#') return this.searchTags(term);

    var encodedTerm = encodeURIComponent(term);
    var url = `https://api.mixcloud.com/search/?q=${encodedTerm}+Kiosk%20Radio&type=cloudcast`;
    return new Promise((resolve, reject) => {
      window.fetch(url).then(response => response.json()).then(data => {
        this.searchResults = this.parseResult(data);
        resolve();
      }).catch(reject);
    })
  }

  searchTags (term) {
    var tags = term.split(',');
    tags.unshift('kioskradio');
    tags = tags.map(tag => encodeURIComponent(tag.replace('#','').replace(/\s/g, '-')));
    var url = `https://api.mixcloud.com/discover/${tags.join('+')}/latest/`;
    console.log('Loading', url);
    return new Promise((resolve, reject) => {
      window.fetch(url).then(response => response.json()).then(data => {
        this.searchResults = this.parseResult(data);
        console.log(this.searchResults);
        resolve();
      }).catch(reject);
    })
  }

  parseResult = (data) => {
    return data.data.map(_ => {
      var episode = { title: _.name, date: moment(_.created_time), url: _.url };
      
      if (_.pictures) episode.image = _.pictures['640wx640h'];

      episode.tags = _.tags ? _.tags.map(tag => tag.name.toLowerCase()) : [];
      episode.staffPick = episode.tags.indexOf('staffpick') > -1;
      episode.tags = episode.tags.filter(tag => tag !== 'staffpick').filter(tag => tag !== 'kioskradio');
      
      episode.title = episode.title.split('@')[0];

      return episode;
    });
  } 
}
